import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { StatoManutenzione } from 'src/app/models/stato-manutenzione';
import { StatoManutenzioneService } from 'src/app/services/stato-manutenzione.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { StatiManutenzioneFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'stati-manutenzione',
  templateUrl: './stati-manutenzione.component.html',
  styleUrls: ['./stati-manutenzione.component.scss']
})
export class StatiManutenzioneComponent implements OnInit {

  headingText: string = 'Tipi di danno';


  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),

  ];
  constructor(public statoManutenzioneService: StatoManutenzioneService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<StatiManutenzioneComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un tipo di danno';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }
  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (statoManutenzione: StatoManutenzione) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il tipo di danno ${statoManutenzione.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.statoManutenzioneService.delete(statoManutenzione);
          this.toast.success('Tipo di danno eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione tipo di danno fallita.", "Errore!");
    }
  }



  editFunction = async (statoManutenzione: StatoManutenzione) => {
    try {
      let dialogRef = this.dialog.open(StatiManutenzioneFormComponent, { data: statoManutenzione });
      dialogRef.afterClosed().subscribe(async (data: StatoManutenzione) => {
        if (data) {

          Object.assign(statoManutenzione, data);

          await this.statoManutenzioneService.edit(statoManutenzione);

          this.toast.success('Tipo di danno modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica tipo di danno fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(StatiManutenzioneFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(statoManutenzione?: StatoManutenzione) {
    if (statoManutenzione) {
      try {
        await this.statoManutenzioneService.create(statoManutenzione)
        this.toast.success('Tipo di danno creato!')
      }
      catch (e) {
        this.toast.error('Creazione tipo di danno fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
